module.exports = __webpack_public_path__ + "media/images/logo-56052978a2acd1b217e36dfcec384ba9.svg";